import 'fontsource-roboto'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import URI from 'urijs'

import Loading from '../components/loading'
import config from '../config'
import CategoryListHandlerBar from '../containers/category/CategoryListHandlerBar'
import CategoryListTable from '../containers/category/CategoryListTable'
import HorizontalGridDivider from '../containers/horizontalGridDivider'
import ListTitleBar from '../containers/listTitleBar'
import SideMenu from '../containers/sideMenu'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivder from '../containers/verticalGridDivider'
import { getCategoryListRequest } from '../redux/category/actions'
import {
  getCategoryList,
  getIsFetchingCategoryList
} from '../redux/category/selectors'
import { getQuery } from '../utils/common'

const CategoryList = () => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const history = useHistory()
  const query = getQuery(search)
  const {
    page = 1,
    limit = config.api.defaultQuery.limit,
    sortBy = config.api.defaultQuery.sortBy,
    sortDirection = config.api.defaultQuery.sortDirection,
    type,
    q
  } = query

  const categoryList = useSelector(getCategoryList)
  const isFetchingCategoryList = useSelector(getIsFetchingCategoryList)

  useEffect(() => {
    dispatch(
      getCategoryListRequest({
        page,
        limit,
        sortBy,
        sortDirection,
        type,
        q
      })
    )
  }, [search])

  const handleChangePage = (_event: unknown, newPage: number) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page: newPage + 1,
          limit,
          sortBy,
          sortDirection,
          q
        })
    )
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page,
          limit: event.target.value,
          sortBy,
          sortDirection,
          q
        })
    )
  }

  return (
    <HorizontalGridDivider>
      <SideMenu />
      <VerticalGridDivder>
        <TopBar />
        <StyledMain>
          <ListTitleBar title={'Category List'} />
          <CategoryListHandlerBar />
          {isFetchingCategoryList ? (
            <Loading />
          ) : (
            <CategoryListTable
              categoryList={categoryList}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </StyledMain>
      </VerticalGridDivder>
    </HorizontalGridDivider>
  )
}

export default CategoryList
